<template>
  <section class="hero" v-if="user">
    <div class="hero-body">
      <div class="columns">
        <div class="column">
          <h3 class="title">
            <span class="icon">
              <i class="mdi mdi-clipboard-account"></i>
            </span>
            {{user.email}}
          </h3>          
        </div>
        <div class="column">
           <form name="user-profile">
              <div class="field" for="email">
                <label class="label">Email</label>
                <div class="control">
                  <input class="input" type="email" name="email" placeholder="email" maxlength=30 v-model="user.email" disabled></input>
                </div>
              </div>
              <div class="field" for="id">
                <label class="label">Id</label>
                <div class="control">
                  <input class="input" type="id" name="id" placeholder="id" maxlength=30 v-model="user.id" disabled></input>
                </div>
              </div>
              <!-- <input class="button" type="submit" :disabled="disabled" @click.prevent="onSubmit"></input> -->
              <section class="section">
                <!-- <div class="notification is-danger" v-if="error">{{error.message}}</div> -->
              </section>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Account",
  data() {
    return {};
  },
  computed: {
    disabled() {
      return this.name !== null || this.email === "" || this.password === "";
    },
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user(value) {
      if (value == null && value == "undefined") {
        this.$router.push("/");
      }
    }
  },
  methods: {
    onSubmit() {
      // TODO: Edit user
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Account.vue